import access_to_services from './access_to_services'
import celebrate from './celebrate'
import classroom_support from './classroom_support'
import collaborate from './collaborate'
import combination from './combination'
import comfort from './comfort'
import community from './community'
import conflict_resolution from './conflict_resolution'
import correct from './correct'
import crosshair from './crosshair'
import culture from './culture'
import expression from './expression'
import hatch_bg from './hatch_bg'
import health from './health'
import home from './home'
import incorrect from './incorrect'
import inspire from './inspire'
import learning_success from './learning_success'
import listen from './listen'
import mastery from './mastery'
import mentors from './mentors'
import neighborhood_cohesion from './neighborhood_cohesion'
import networks from './networks'
import next from './next'
import plus from './plus'
import prev from './prev'
import problem_solving from './problem_solving'
import protective from './protective'
import relationships from './relationships'
import risk from './risk'
import role_models from './role_models'
import school from './school'
import stability from './stability'
import supportive_relationships from './supportive_relationships'
import temperment from './temperment'
import understanding from './understanding'

export default {
  'access-to-services': access_to_services,
  'celebrate': celebrate,
  'classroom-support': classroom_support,
  'collaborate': collaborate,
  'combination': combination,
  'comfort': comfort,
  'community': community,
  'conflict-resolution': conflict_resolution,
  'correct': correct,
  'svg-crosshair': crosshair,
  'culture': culture,
  'expression': expression,
  'hatch-bg': hatch_bg,
  'health': health,
  'home': home,
  'incorrect': incorrect,
  'inspire': inspire,
  'learning-success': learning_success,
  'listen': listen,
  'mastery': mastery,
  'mentors': mentors,
  'neighborhood-cohesion': neighborhood_cohesion,
  'networks': networks,
  'next': next,
  'plus': plus,
  'prev': prev,
  'problem-solving': problem_solving,
  'protective': protective,
  'relationships': relationships,
  'risk': risk,
  'role-models': role_models,
  'school': school,
  'stability': stability,
  'supportive-relationships': supportive_relationships,
  'temperment': temperment,
  'understanding': understanding
}


// WEBPACK FOOTER //
// ./src/components/svg/index.js